import styled from "@emotion/styled";

export const RaffleTextBanner = styled.div`
  background-color: var(--tw-indigo-600);
  color: white;
  padding: 16px;
  text-align: center;
  border-radius: 8px;
  font-size: 1.25rem;
  font-weight: 600;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
`;
